import React, {
  useState,
  createContext,
  useContext,
  type ReactNode,
  useMemo,
  type Dispatch,
  type SetStateAction,
} from "react";

import { type BrandNameType } from "@fwa/src/types";

type BrandContextType = [
  BrandNameType,
  Dispatch<SetStateAction<BrandNameType>>,
];

const defaultState: BrandContextType = ["cruk", () => null];

export const BrandContext = createContext<BrandContextType>(defaultState);

// Adding brandName as a prop to allow providers parent to
// set theme as well as its children.
export const BrandContextProvider = ({
  initialBrandName,
  children,
}: {
  initialBrandName: BrandNameType;
  children: ReactNode;
}) => {
  const [brandName, setBrandName] = useState(initialBrandName);
  const value = useMemo(
    () => [brandName, setBrandName],
    [brandName],
  ) as BrandContextType;

  return (
    <BrandContext.Provider value={value}>
      <div data-theme={brandName}>{children}</div>
    </BrandContext.Provider>
  );
};

export const useBrandContext = () => useContext(BrandContext);
